import { pdf } from "@react-pdf/renderer";
import { PDFComponent } from "../PDFComponent/PDFComponent";
import { saveAs } from "file-saver";

export function downloadPDF(resumen, detalle, allDetalleState){
    try {
        const PDF = <PDFComponent resumen={resumen} detalle={detalle} allDetalleState={allDetalleState} />;
        pdf(PDF).toBlob()
        .then((result)=>{
            saveAs(result, "cotizado.pdf");
            //return true;
        }).catch((err)=> {
            console.log(err);
            //return false;
        });
    } catch (error) {
        console.log(error);
    }
}